import { render, staticRenderFns } from "./widgets_hot_values.vue?vue&type=template&id=077c4134&scoped=true&"
import script from "./widgets_hot_values.vue?vue&type=script&lang=js&"
export * from "./widgets_hot_values.vue?vue&type=script&lang=js&"
import style0 from "./widgets_hot_values.vue?vue&type=style&index=0&id=077c4134&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c4134",
  null
  
)

export default component.exports